export default {
  apiUrl: '/api/aromas',
  dataPath: 'result.rows',
  paginationPath: 'data',
  trackBy: 'id',
  detailRowComponentName: 'aroma-editor',
  preloadList: [],
  onEachSide: 1,
  sortOrder: [{
    field: 'id',
    sortField: 'id',
    direction: 'DESC',
  }],
  paginationTemplate: {
    class: '',
    template: '총 {total}개 중의 {from} 부터 {to}',
  },
  fields: [
    {
      name: '__checkbox',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
    {
      name: 'id',
      title: '<p style="white-space: nowrap">아이디</p>',
      sortField: 'id',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'name',
      title: '<i style="white-space: nowrap">한글 이름</i>',
      sortField: 'name',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'code',
      title: '<i style="white-space: nowrap">영어 이름</i>',
      sortField: 'code',
      titleClass: 'text-center',
      dataClass: 'text-right',
    },
    {
      name: 'img',
      title: '<i style="white-space: nowrap">이미지</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'imgField',
    },
    {
      name: 'category',
      title: '<i style="white-space: nowrap">카테고리</i>',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'inputLayout',
    },
    {
      name: 'is_checked',
      title: '<p style="white-space: nowrap">발행</p>',
      sortField: 'is_checked',
      titleClass: 'text-center',
      dataClass: 'text-right',
      callback: 'toggleField',
    },
    {
      name: '__slot:actions',
      title: '편집 삭제',
      titleClass: 'center aligned',
      dataClass: 'center aligned',
    },
  ],
};



// WEBPACK FOOTER //
// ./src/spa/components/board/aroma/Config.js